/*
 * @Author       : Tom
 * @Date         : 2019-12-21 14:30:34
 * @LastEditors  : Tom
 * @LastEditTime : 2020-01-20 18:08:05
 * @FilePath     : /shop_front_end/src/lib/request.js
 * @Description  : 
 */
import Vue from 'vue'
import router from '../router'
import Axios from 'axios'
import { loadPageVar, isLogin, getToken, clear } from '../lib/tool'
import { baseURL, STORE_ID } from './config'
console.log(baseURL)

const instance = Axios.create({
  // baseURL:'http://192.168.1.165:81/index.php'
  baseURL: baseURL,
  // headers: {'Content-Type': 'application/json'}
  headers: {'Content-Type': 'Content-Type: application/x-www-form-urlencoded'}
})

// 请求拦截器
instance.interceptors.request.use(function (config) {

  let token;
  /**
   * 除了登录请求外都需要加验证
   * */ 
  if((!(loadPageVar(config.url,'action') === 'UserLogin')) && !(loadPageVar(config.url,'action') == 'Reset_password')){
    if(!isLogin()){
      token = getToken('token')
	  localStorage.setItem('token',token)
      config.headers = {
        ...config.headers,
        Authorizations:'Bearer ' + token
      }
    } else {
      // TODO:不存在token跳转
      clear()
      router.push('/login')
    }
  }

  return config
}, function (error) {
  return Promise.reject(error)
})

// 响应拦截器
instance.interceptors.response.use(function (response) {

  let { status, data } = response
  if(status === 200){

    if(typeof data === 'object'){

      if(data.code === '400' && data.code === '400'){
        clear()
        router.push('/login')
        return
      }

      return data
    }
    
    return {
      code:401,
      message:'数据异常请联系客服！'
    }
  }

  return {
    code:401,
    message:'网络不稳定！'
  }

}, function (error) {
  return Promise.reject(error)
})

class Requset {
  get(url,config){
    url += '&store_id=' + STORE_ID
    return instance.get(url,config)
  }

  post(url,data,config = {}){
    url += '&store_id=' + STORE_ID
    return instance.post(url,data,config)
  }

  formDataPost(url, data, config = {}) {
    url += '&store_id=' + STORE_ID
    config = {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      transformRequest: [function (data) {
        let ret = ''
        for (let it in data) {
          ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
        }
        return ret
      }],
      ...config
    }
    return instance.post(url,data,config)
  }

  /**
   * @name 流文件保存 
   * @param { url | String } 文件下载路径
   */
  download(url,data = {}){
    url += '&store_id=' + STORE_ID
    let config = {
      responseType: 'blob'
    }

    instance.post(url,data,config).then(res => {
      if (!res) {
        return;
      }

      let url = window.URL.createObjectURL(new Blob([res]))
      let link = document.createElement('a')
      link.style.display = 'none'
      link.href = url
      link.setAttribute('download', 'file.xls')
      document.body.appendChild(link)
      link.click()

    })
  }

  /**
   * @name 文件下载
   */
  BandParamDownload(url,data){
    url += '&store_id=' + STORE_ID
    instance.post(url,data).then(res => {
      let { code, data, message } = res
      if(code === 200){
        window.open(data)
      }
    })
  }
}
const request = new Requset()
Vue.prototype.$request = request

export default request